export const ANALYTICS_TARGET_INFO_SECTION = "info_section";
export const ANALYTICS_TARGET_VIEW_ALL_PRODUCTS = "view_all_products";
